{
  "carrierLabel": "Syarikat pengangkutan",
  "searchPlaceholder": "Cari mengikut nama",
  "selectAsCarrier": "Pilih \"{name}\" sebagai Pengangkut",
  "typeToSearch": "Taip untuk mencari syarikat"
}
